import {ActionButton, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {ApiPathsService} from "../../../app/api-paths.service";
import {FieldViewerComponent} from "../../../app/shared/field-viewer/field-viewer.component";
import {RichiediProdotto} from "./ProductUtility";
import {trovaBreadcrumb} from "../../Utility/Utility";

function Le_mie_ricerche() {
  var OBJ: OggettoConfig = {
    Id: "Le_mie_ricerche",
    RestRoute: '/prodotti/filtri',
    listIsGet:true,
    listView:'card-list',
    noCardBody: true,
    ListResponseHasData:true,
    PrintHeaders:[],
    cardClass:'lista-ricerche',
    asyncFullResponseMap: (x, component, callBack )=>{
      component.api.ClassicPost('/prodotti/categorie/list', {}).subscribe(cat=>{
        callBack({...x, data: x.data.map(d => ({...d, categorie: cat}))});
      })
    },
    Headers:[
      CampoAggiuntivo.Html("", (x)=> {

        x.FiltriVisibili = x.filtri?.filter(y=>!['page', 'size'].includes(y.codice)).map(y=>({...y, label:y.codice == 'cat_id' ? trovaBreadcrumb(x.categorie, y.filtri).map(z=>z.categoria).join(" · ") : y.filtri,  breadcrumb:y.codice == 'cat_id' ? trovaBreadcrumb(x.categorie, y.filtri).map(z=>z.categoria) : null})) ?? [];

        return `
      <div class="ric-card" id="ric-1">
      <div style="flex:1;min-width:0;">
        <div class="ric-name" >
         <span class="icon-search"></span>
         ${x.FiltriVisibili.map(f => f.label).join(" · ")}
        </div>
        <div class="ric-tags">

          ${x.FiltriVisibili.map(f => f.breadcrumb?.length ? f.breadcrumb.map(b=>`
          <span class="ric-tag">
            ${b}
            <button class="ric-tag-x" ">×</button>
          </span>
          `).join("") :`
          <span class="ric-tag">
            ${f.label}
            <button class="ric-tag-x" ">×</button>
          </span>
          `).join("")}
        </div>
      </div>
    </div>
      `
      }, ()=>true,{azioni:[
          {
            label: "x",
            type:'func',
            func: (field, bottone, campo, Oggetto, api: ApiPathsService, component:FieldViewerComponent)=>{
              api.ClassicPost('/prodotti/filtri/delete',{id: Oggetto.id}).subscribe(data=>{
                component.refresh.emit();
              })
            },
            class:'ric-del-btn'
          }
        ],
        onClick: (x, component)=>{
          var filters:any = x.filtri.reduce((acc, item)=> {
            acc[item.codice] = item.filtri;
            return acc;
          }, {});

          console.log('filters', filters);
          component.router.navigate(['marketplace/shared/dynamiclist', 'catalogo'], {queryParams:{...filters, fromRicerche: 'true'}})
        }

      })
    ],
    MenuItems:[
      {
        path: 'shared/dynamiclist/Le_mie_ricerche',
        title: "Le mie ricerche",
        icon: "fas fa-cart",
        class: "",
        capacita: [],
      }
    ]
  }
  return OBJ;
}


export var Le_mie_ricercheEnv = () => {
  var env: any = {
    Modules: {
      "Le_mie_ricerche": true
    },
    Cruds: [Le_mie_ricerche()],
    Menu: [...Le_mie_ricerche().MenuItems]
  }
  return env;

}
